import axios from "axios";
import {
  IP
} from "../index.js";
/* 护士信息维护 */
export async function selectNurse(data) {
  var resp = await axios.post(`${IP}/admin/nurse/select`, data);
  return resp.data;
}

export async function addNurse(data) {
  var resp = await axios.post(`${IP}/admin/nurse/add`, {
    ...data,
  });
  return resp.data;
}

export async function updateNurse(data) {
  var resp = await axios.post(`${IP}/admin/nurse/update`, {
    ...data,
  });
  return resp.data;
}

export async function deleteNurse(data) {
  var resp = await axios.post(`${IP}/admin/nurse/delete`, data);
  return resp.data;
}

/* 预约订单 */
export async function selectNurseOrder(data) {
  var resp = await axios.post(`${IP}/admin/nurse/selectOrder`, data);
  return resp.data;
}

export async function addNurseOrder(data) {
  var resp = await axios.post(`${IP}/admin/nurse/addOrder`, {
    ...data
  });
  return resp.data;
}

export async function updateNurseOrder(data) {
  var resp = await axios.post(`${IP}/admin/nurse/updateOrder`, {
    ...data
  });
  return resp.data;
}

export async function deleteNurseOrder(data) {
  var resp = await axios.post(`${IP}/admin/nurse/deleteOrder`, data);
  return resp.data;
}

